import { BaseEntity } from "./base-entity";
export class BaseTenantEntity extends BaseEntity {
    tenantId;
    constructor(value) {
        super(value);
        this.tenantId = value.tenantId;
    }
}
//# sourceMappingURL=base-tenant-entity.js.map